// extracted by mini-css-extract-plugin
export default {"checkout_confirm":"Ya","checkout":"Za","uppercase":"ab","checkoutHero":"bb","checkoutHed":"cb","moneyback":"eb"};
    if(module.hot) {
      // 1726593100858
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  